/**
 * The two primitives that reconciling Samsara against Track-POD needs, shared
 * by `stopTiming` and `routeTiming`.
 *
 * Only these two. Both modules also have a `resolveStatus` with the same name
 * and the same return shape, and they are not the same function: one decides
 * whether a *stop* was served, the other whether a *route* ran, and they
 * disagree deliberately -- a cancelled route outranks a driver who started it,
 * where a serviced stop outranks a geofence that never fired. They stay where
 * they are, next to the rules they encode.
 */

/** A timestamp from either system, or undefined if it is absent or unparseable. */
export function toDate(value: string | null | undefined): Date | undefined {
  if (!value) return undefined
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? undefined : parsed
}

/**
 * Is a driver-entered timestamp close enough to the plan to be believable?
 *
 * The window is a parameter because a stop and a route are judged on different
 * ones: a stop against its planned arrival, a route against its own reference,
 * and the two tolerances are set independently.
 */
export function isPlausibleWithin(
  candidate: Date,
  reference: Date,
  windowHours: number,
): boolean {
  const deltaHours = Math.abs(candidate.getTime() - reference.getTime()) / 3_600_000
  return deltaHours <= windowHours
}
